import { motion } from "framer-motion";

export const PageHero = ({ kicker, title, accent, description, image, imageAlt, imageCaption, testId }) => (
  <section data-testid={testId} className="relative overflow-hidden px-6 pb-20 pt-36 md:pb-28 md:pt-44">
    <div className="absolute right-[-12rem] top-[-12rem] h-96 w-96 rounded-full bg-secondary/20 blur-3xl" />
    <div className="mx-auto grid max-w-7xl items-center gap-12 lg:grid-cols-[1.05fr_0.95fr]">
      <div>
        <motion.p
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-5 text-xs font-semibold uppercase tracking-[0.3em] text-secondary"
        >
          {kicker}
        </motion.p>
        <h1 className="max-w-4xl text-balance text-5xl leading-[1.02] tracking-tight text-primary md:text-7xl">
          <span className="block overflow-hidden pb-1">
            <motion.span
              initial={{ y: "110%" }}
              animate={{ y: 0 }}
              transition={{ duration: 0.85, ease: [0.22, 1, 0.36, 1] }}
              className="block"
            >
              {title}
            </motion.span>
          </span>
          <span className="block overflow-hidden pb-2">
            <motion.span
              initial={{ y: "110%" }}
              animate={{ y: 0 }}
              transition={{ duration: 0.85, delay: 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="block italic text-secondary"
            >
              {accent}
            </motion.span>
          </span>
        </h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.28 }}
          className="mt-6 max-w-2xl text-base leading-relaxed text-muted-foreground md:text-lg"
        >
          {description}
        </motion.p>
      </div>
      {image ? (
        <div>
          <motion.div
            initial={{ opacity: 0, scale: 0.94, rotate: 1.5 }}
            animate={{ opacity: 1, scale: 1, rotate: 0 }}
            transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
            className="image-frame relative hidden aspect-[4/5] overflow-hidden rounded-[2rem] shadow-soft lg:block"
          >
            <img src={image} alt={imageAlt} className="h-full w-full object-cover" />
            <div className="absolute inset-0 bg-primary/10" />
          </motion.div>
          {imageCaption ? (
            <p className="mt-3 hidden text-right text-xs uppercase tracking-[0.18em] text-muted-foreground lg:block">
              {imageCaption}
            </p>
          ) : null}
        </div>
      ) : null}
    </div>
  </section>
);
